/* eslint-disable react/jsx-no-bind */
// @flow
import * as React from 'react';
import { Select } from '@locus-taxy/neo-ui';
import { useBusinessUnits } from 'platform/settings/hooks/useBusinessUnit';

type Props = {
    label: string,
    value: string,
    disabled?: ?boolean,
    onChange: (value: string) => void
};

const BusinessUnitInput = ({ label, value, onChange }: Props): React.Node => {
    const businessUnit = useBusinessUnits();
    const options = React.useMemo(() => {
        if (businessUnit.data) {
            return businessUnit.data.businessUnits.map(
                ({ businessUnitId, name }) => ({
                    label: name,
                    value: businessUnitId
                })
            );
        }

        return [];
    }, [businessUnit.data]);

    return (
        <Select
            value={value}
            label={label}
            placeholder={label}
            onChange={option => onChange(option.value)}
            options={options}
            disabled={false}
            fullWidth
            clearable={false}
        />
    );
};

export default BusinessUnitInput;
